var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":("confirm-modal-" + _vm.id),"title":"Confirmation","footer-class":"d-flex justify-content-between","ok-title":"Yes","ok-variant":"success","cancel-title":"No","cancel-variant":"danger"},on:{"ok":function($event){return _vm.$emit('confirm')}}},[_c('h6',{staticClass:"my-2"},[_vm._v("Are you sure?")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-411d248c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserPanel/Modals/ConfirmModal.vue
// module id = null
// module chunks = 